import * as React from "react";

import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";

import { FavouritesLayout, FavouritesBox, FavouritesToolbar, FavouritesSettings, FavouritesMenu } from "../../components";
import { FavouritesProvider } from "../../providers";

const FavouritesPage: React.FC = () => {
  return (
    <Layout>
      <Header />
      <FavouritesProvider>
        <FavouritesLayout>
          <FavouritesToolbar />
          <FavouritesBox>
            <FavouritesMenu />
            <FavouritesSettings />
          </FavouritesBox>
        </FavouritesLayout>
      </FavouritesProvider>
      <Footer />
    </Layout>
  );
};

export default FavouritesPage;
